import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { TranslateService } from '@ngx-translate/core';
import { catchError, concat, exhaustMap, of, share, switchMap } from 'rxjs';
import { errMessage } from '@ui';
import { SystemConfigurationActions } from '../state/system-configuration/system-configuration.actions';
import { SystemConfigurationService } from '../../services/system-configuration.service';
import { SharedActions } from '../state/shared/shared.actions';

export const loadSystemConfiguration$ = createEffect(
  (actions$ = inject(Actions), service = inject(SystemConfigurationService)) =>
    actions$.pipe(
      ofType(SystemConfigurationActions.loadSystemConfiguration),
      switchMap(() =>
        concat(
          of(SystemConfigurationActions.setIsLoading({ isLoading: true })),
          service.get().pipe(
            switchMap((config) => [
              SystemConfigurationActions.loadSystemConfigurationSuccess({ config }),
              SystemConfigurationActions.setIsLoading({ isLoading: false }),
            ]),
            catchError((response) => [
              SystemConfigurationActions.loadSystemConfigurationFail(),
              SystemConfigurationActions.setIsLoading({ isLoading: false }),
              SharedActions.showMessage({ error: errMessage(response) }),
            ]),
          ),
        ),
      ),
    ),
  { functional: true },
);

export const saveSystemConfiguration$ = createEffect(
  (
    actions$ = inject(Actions),
    service = inject(SystemConfigurationService),
    translate = inject(TranslateService),
  ) =>
    actions$.pipe(
      ofType(SystemConfigurationActions.saveSystemConfiguration),
      exhaustMap(({ config }) =>
        concat(
          of(SystemConfigurationActions.setIsSaving({ isSaving: true })),
          service.save(config).pipe(
            switchMap((saved) => [
              SystemConfigurationActions.saveSystemConfigurationSuccess({ config: saved }),
              SystemConfigurationActions.setIsSaving({ isSaving: false }),
              SharedActions.showMessage({
                success: translate.instant('TOASTS.SYSTEM_CONFIGURATION_SAVED'),
              }),
            ]),
            catchError((response) => [
              SystemConfigurationActions.saveSystemConfigurationFail(),
              SystemConfigurationActions.setIsSaving({ isSaving: false }),
              SharedActions.showMessage({ error: errMessage(response) }),
            ]),
          ),
        ),
      ),
      share(),
    ),
  { functional: true },
);
